import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = [
    { href: "#evento", label: "L'Evento" },
    { href: "#iscrizione", label: "Iscrizione" },
    { href: "#giuria", label: "Giuria" },
    { href: "#ranking", label: "Ranking Arena" }, // <-- AGGIUNTO QUI
    { href: "#chi-siamo", label: "Chi Siamo" },
  ];

  return (
    <nav
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bb-glass" : ""
      }`}
      style={{ paddingTop: "env(safe-area-inset-top)" }}
    >
      <div className="bb-container flex items-center justify-between px-6 md:px-12 py-5">
        <a href="#top" data-testid="logo-link" className="bb-display text-2xl tracking-widest" style={{ color: "var(--bb-primary)" }}>
          BEER<span style={{ color: "#fff" }}>BATTLE</span>
        </a>
        <div className="hidden md:flex items-center gap-8 lg:gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="text-sm uppercase tracking-widest text-zinc-300 hover:text-[var(--bb-primary)] transition-colors"
            >
              {l.label}
            </a>
          ))}
          <a href="#iscrizione" data-testid="nav-cta-iscriviti" className="bb-btn-outline text-xs">
            Iscriviti
          </a>
        </div>
        <button
          className="md:hidden text-zinc-200"
          onClick={() => setOpen(!open)}
          data-testid="mobile-menu-toggle"
          aria-label="Menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>
      {open && (
        <div data-testid="mobile-menu" className="md:hidden bb-glass border-t border-zinc-800 px-6 py-6 flex flex-col gap-5">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="text-sm uppercase tracking-widest text-zinc-300"
            >
              {l.label}
            </a>
          ))}
        </div>
      )}
    </nav>
  );
}